var SwaggerDefinition = require('@/http/swagger/openapi.json') //with path

const ApiKey = '0d79f5cb-a857-4d7f-863b-f7a053ca52be'
SwaggerDefinition.host = 'api.hoverlay.com'
//SwaggerDefinition.host = 'hov-mrs-sand.herokuapp.com'
//SwaggerDefinition.host = 'hov-mrs-stag.herokuapp.com'

export { SwaggerDefinition, ApiKey }
